import React from "react";
import photo1 from "../../Assets/Images/landing/photo-1.jpg";
import photo2 from "../../Assets/Images/landing/photo-2.jpg";
import photo3 from "../../Assets/Images/landing/photo-3.jpg";
import photo4 from "../../Assets/Images/landing/photo-4.jpg";
import photo5 from "../../Assets/Images/landing/photo-5.jpg";
import photo6 from "../../Assets/Images/landing/photo-6.jpg";

const collage = [
  { src: photo1, cls: "fp-hero__collage-item--1", delay: "0s" },
  { src: photo4, cls: "fp-hero__collage-item--2", delay: "0.3s" },
  { src: photo3, cls: "fp-hero__collage-item--3", delay: "0.6s" },
  { src: photo5, cls: "fp-hero__collage-item--4", delay: "0.9s" },
  { src: photo2, cls: "fp-hero__collage-item--5", delay: "1.2s" },
  { src: photo6, cls: "fp-hero__collage-item--6", delay: "1.5s" },
  { src: photo1, cls: "fp-hero__collage-item--7", delay: "1.8s" },
  { src: photo3, cls: "fp-hero__collage-item--8", delay: "2.1s" },
];

const FeaturesHero: React.FC = () => {
  return (
    <section className="fp-hero lr-grain">
      <div className="fp-hero__collage">
        {collage.map((c, i) => (
          <div
            key={i}
            className={`fp-hero__collage-item ${c.cls}`}
            style={{ animationDelay: c.delay }}
          >
            <img src={c.src} alt="" loading="lazy" />
            <div className="fp-hero__collage-stamp">© eZy</div>
          </div>
        ))}
        <div className="fp-hero__veil" />
        <div className="fp-hero__orb fp-hero__orb--1" />
        <div className="fp-hero__orb fp-hero__orb--2" />
      </div>

      <div className="fp-hero__content">
        <span className="fp-hero__badge">
          <span />
          Key Features
        </span>
        <h1 className="fp-hero__title">
          <span className="lr-hero-word" style={{ animationDelay: "0.05s" }}>
            <span className="lr-text-gradient">Everything you need</span>
          </span>{" "}
          <span className="lr-hero-word" style={{ animationDelay: "0.2s" }}>
            <span className="lr-text-gradient">to protect</span>
          </span>{" "}
          <span className="lr-hero-word" style={{ animationDelay: "0.35s" }}>
            <span className="lr-text-gradient">your photos.</span>
          </span>
        </h1>
        <p className="fp-hero__subtitle">
          Discover the power of these key features and elevate your image branding and
          protection strategies to new heights.
        </p>
      </div>
    </section>
  );
};

export default FeaturesHero;
